import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#0A0A0A" }}>
      <div className="pe-card rounded-2xl p-10 max-w-md w-full text-center">
        <div className="overline mb-2">Pleasure Empire</div>
        {status === "loading" && <><Loader2 size={40} className="animate-spin text-[#D4AF37] mx-auto mb-4" /><p className="text-[#A0A0A0]">Verifying your email…</p></>}
        {status === "ok" && <>
          <CheckCircle2 size={48} className="text-[#22c55e] mx-auto mb-4" />
          <h2 className="font-heading text-2xl mb-2">Email verified ✓</h2>
          <p className="text-[#A0A0A0] text-sm mb-6">Your account is secured. Welcome to the Empire.</p>
          <button data-testid="verified-continue" onClick={() => navigate("/discover")} className="btn-gold rounded-full px-6 py-2 text-sm">Enter the Empire</button>
        </>}
        {status === "error" && <>
          <XCircle size={48} className="text-[#E63946] mx-auto mb-4" />
          <h2 className="font-heading text-2xl mb-2">Link invalid or expired</h2>
          <p className="text-[#A0A0A0] text-sm mb-6">Please request a new verification email from your profile.</p>
          <button data-testid="verify-back" onClick={() => navigate("/discover")} className="btn-outline-gold rounded-full px-6 py-2 text-sm">Go to app</button>
        </>}
      </div>
    </div>
  );
}
